customElements.component = 'back-to-top';

if (!customElements.get(customElements.component)) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('button');
      this.offset = Number(this.dataset.offset) || window.innerHeight;
      this.ticking = false;

      this.onScroll = this.onScroll.bind(this);
      this.scrollToTop = this.scrollToTop.bind(this);
    }

    connectedCallback() {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.button.addEventListener('click', this.scrollToTop);
      this.toggle();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      this.button.removeEventListener('click', this.scrollToTop);
    }

    onScroll() {
      if (this.ticking) return;

      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.toggle();
        this.ticking = false;
      });
    }

    toggle() {
      const isVisible = window.scrollY > this.offset;

      this.classList.toggle('is-visible', isVisible);
      this.button.tabIndex = isVisible ? 0 : -1;
    }

    scrollToTop() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      this.button.blur();
    }
  }

  customElements.define(customElements.component, BackToTop);
}
